import { Anchor, Button, Drawer, Flex, Group, Text } from '@mantine/core';
import { useDevice } from '@zala-team/ui-web';
import { type FC, useState } from 'react';
import { ZalaLogo } from '../logo/ZalaLogo';

const links = [
	{ link: '#web-features', label: 'Tu web de turnos' },
	{ link: '#features', label: 'Funcionalidades' },
	// { link: '#pricing', label: 'Precios' },
	{ link: '#contact', label: 'Contacto' },
];

export type HeaderSimpleProps = {
	menuOpened: boolean;
	menuClose: () => void;
	menuToggle: () => void;
	sticky?: boolean;
};
export const HeaderSimple: FC<HeaderSimpleProps> = ({ menuOpened, menuClose, sticky = false }) => {
	const { isMobile } = useDevice();

	const [active, setActive] = useState(links[0].link);

	const items = links.map((link) => (
		<Anchor
			variant={'transparent'}
			key={link.label}
			href={link.link}
			c={'var(--color-text)'}
			data-active={active === link.link || undefined}
			onClick={(event) => {
				event.preventDefault();
				const element = document.getElementById(link.link.replace('#', ''));
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' });
					// setActive(link.link);
				}
				setActive(link.link);
				menuClose();
			}}
		>
			{link.label}
		</Anchor>
	));

	return (
		<header>
			<Drawer
				opened={menuOpened}
				onClose={menuClose}
				size='xl'
				position={'right'}
				withCloseButton
				styles={{ header: { backgroundColor: 'var(--website-color-body)' }, content: { backgroundColor: 'var(--website-color-body)' } }}
				title={
					<Group gap={'3xs'}>
						<ZalaLogo size={{ base: 26, md: 30 }} />
						<Text fz={20} fw={700}>
							Zala
						</Text>
					</Group>
				}
			>
				<Flex direction={'column'} flex={1} gap={'md'} align={'flex-start'}>
					{items}
					<Group justify={'center'}>
						<Button component='a' color='primary' href='https://panel.zala.app/' rel='noreferrer' target={'_blank'}>
							Iniciar sesión
						</Button>
					</Group>
				</Flex>
			</Drawer>
			<Group justify='space-between' align='center'>
				<Group gap={'xs'} h={{ base: 26, md: sticky ? 30 : 36 }} ml={sticky ? '3xs' : undefined} m={isMobile ? 0 : undefined}>
					<ZalaLogo size={{ base: sticky ? 24 : 26, md: sticky ? 26 : 30 }} />
					<Text fz={{ base: sticky ? 18 : 20 }} fw={700}>
						Zala
					</Text>
				</Group>
				<Group>
					{sticky ? (
						<Button
							component='a'
							color='primary'
							href='https://panel.zala.app/signup'
							rel='noreferrer'
							target={'_blank'}
							size={sticky ? 'sm' : undefined}
						>
							Comenzar gratis
						</Button>
					) : (
						<Anchor
							size={sticky ? 'compact-sm' : undefined}
							c='primary'
							variant={'transparent'}
							href='https://panel.zala.app/'
							rel='noreferrer'
							target={'_blank'}
						>
							Iniciar sesión
						</Anchor>
					)}
					{/*<Burger opened={menuOpened} onClick={menuToggle} size='sm' hiddenFrom='sm' />*/}
				</Group>
			</Group>
		</header>
	);
};
